export default "__VITE_ASSET__76241167__"